module.exports = __webpack_public_path__ + "images/help/logo-roadmap@2x-30f5ab5c931a81c80e32f0d5ccbe952d.png";